import { render } from "./day-one.vue?vue&type=template&id=182b88f4"
import script from "./day-one.vue?vue&type=script&lang=js"
export * from "./day-one.vue?vue&type=script&lang=js"

import "./day-one.vue?vue&type=style&index=0&id=182b88f4&lang=scss"
script.render = render

export default script